import { Component, Fragment } from 'react';
import { loadOnboardingTourBanner } from 'onboarding-tours/util/banner';
// @ts-expect-error: not typed yet
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import PickersContext from 'ContentComponents/context/PickersContext';
import { makeAsyncComponentWithOverlay, makeAsyncComponent
// @ts-expect-error: not typed yet
} from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
// @ts-expect-error: not typed yet
import makeAsyncEmojiPickerContent from 'ui-addon-emoji-picker/picker/makeAsyncEmojiPickerContent';
import OnboardingTour from 'onboarding-tours/components/OnboardingTour';
import UITour from 'ui-shepherd-react/tour/UITour';
import { SECTIONS_LIBRARY_TOUR, SECTIONS_LIBRARY_TOUR_STEPS } from 'ContentEditorUI/constants/tours';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncCtaPicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: 'cta-picker' */'cta-picker/components/CTAPickerContainer'));
const AsyncEmojiPicker = makeAsyncEmojiPickerContent(() => import(
// @ts-expect-error: not typed yet
/* webpackChunkName: "emoji-picker" */
'ui-addon-emoji-picker/picker/EmojiPickerContent'));
const AsyncFilePicker = makeAsyncComponentWithOverlay(() => import(
// @ts-expect-error: not typed yet
/* webpackChunkName: "file-picker" */
'ContentEditorUI/components/shared/FilePicker'));
const AsyncMediaBridgePicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "media-bridge-picker" */'media-bridge-lib/components/media-picker/MediaPicker'));
const AsyncContentAssistanceToolbar = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "ContentAssistanceToolbar" */'ContentEditorUI/containers/ContentAssistanceToolbarContainer'));
const AsyncContentAssistantAutocompleteMenu = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "ContentAssistanceAutocompleteMenu" */'ContentEditorUI/containers/ContentAssistanceAutocompleteContainer'));
const AsyncPersonalizationUpgradeButton = makeAsyncComponent(() => import(
// @ts-expect-error: not typed yet
/* webpackChunkName: "personalization-upgrade-button" */
'page-editor-ui/components/PersonalizationUpgradeButton'));
const AsyncSubscriptionTypeSelect = makeAsyncComponent(() => import( /* webpackChunkName: "subscription-type-select" */'ui-gdpr-components/components/SubscriptionTypeSelect'));
const AsyncLegacyVideoPickerFacade = makeAsyncComponent(() => import( /* webpackChunkName: "legacy-video-picker-facade" */'video-components-external/components/LegacyVideoPickerFacade').then(module => module.LegacyVideoPickerFacade));
const pickerComponents = {
  CtaPicker: AsyncCtaPicker,
  EmojiPicker: AsyncEmojiPicker,
  FilePicker: AsyncFilePicker,
  MediaBridgePicker: AsyncMediaBridgePicker,
  HubSpotVideoPicker: AsyncLegacyVideoPickerFacade,
  PersonalizationUpgradeButton: AsyncPersonalizationUpgradeButton,
  SubscriptionTypeSelect: AsyncSubscriptionTypeSelect,
  ContentAssistanceToolbar: AsyncContentAssistanceToolbar,
  ContentAssistantAutocompleteMenu: AsyncContentAssistantAutocompleteMenu
};
class RootTreeWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasStartedTourInParentFrame: false
    };
  }
  componentDidMount() {
    loadOnboardingTourBanner();
  }
  render() {
    const {
      children
    } = this.props;
    const client = new DataFetchingClient();
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(PickersContext.Provider, {
        value: pickerComponents,
        children: /*#__PURE__*/_jsx(UITour, {
          tour: SECTIONS_LIBRARY_TOUR,
          config: {
            steps: SECTIONS_LIBRARY_TOUR_STEPS
          },
          activateOnMount: false,
          children: /*#__PURE__*/_jsxs(DataFetchingClientProvider, {
            client: client,
            children: [children, /*#__PURE__*/_jsx(OnboardingTour, {}), /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
              children: ({
                MicroappOnboardingTour
              }) => /*#__PURE__*/_jsx(MicroappOnboardingTour, {})
            })]
          })
        })
      })
    });
  }
}
export default RootTreeWrapper;